import { useIsWithinTailWindBreakpoint } from './useIsWithinTailWindBreakpoint';

export function useIsMobile() {
  return useIsWithinTailWindBreakpoint('md');
}
